exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fadein-enter-active[data-v-5b0c9936],.fadein-leave-active[data-v-5b0c9936]{-webkit-transition:opacity 1s;transition:opacity 1s;position:fixed;top:0;left:0;width:100%}.fadein-enter[data-v-5b0c9936],.fadein-leave-to[data-v-5b0c9936]{opacity:0}", ""]);

// exports
